<template>
  <div class="index">
    <div class="main-wrapper" v-if="showIndex">
      <!-- <Button type="primary" @click="clear">清缓存</Button> -->
      <div class="logo-con">
        <div class="logo"></div>
        <div class="cloud-3"></div>
      </div>
      <div class="cloud-2"></div>
      <div class="cloud-1"></div>
      <div class="mountain"></div>
      <div class="water-4"></div>
      <div class="index-title">
        <div class="hit-text"></div>
        <div class="dou"></div>
        <div class="title-after"></div>
        <div class="small-titlle"></div>
      </div>
      <div class="waterfall-top"></div>
      <!-- 船 -->
      <div class="boat">
        <!-- <div class="front-quant"></div>
        <div class="back-quant"></div>-->
        <!-- <div class="water-3"></div> -->
      </div>
      <div class="water-3"></div>
      <div class="waterfall-middle"></div>
      <div class="quant-con">
        <div class="front-quant"></div>
        <div class="back-quant"></div>
      </div>
      <div class="water-1"></div>
      <div class="water-2"></div>
      <div class="waterfall-botom"></div>
    </div>
    <div class="bottom-bg"></div>
    <div class="bottom-container">
      <div class="game-award" @click="showAwardModal = !showAwardModal"></div>
      <div class="game-start" @click="startGame">
        <div class="left-drumstick"></div>
        <div class="right-drumstick"></div>
      </div>
      <div class="game-rule" @click="showRuleModal = !showRuleModal"></div>
    </div>
    <!-- 游戏次数 -->
    <div class="game-num">安康！您目前拥有{{gameNum}}次游戏机会</div>

    <!-- 弹窗蒙版 -->
    <div class="masking" v-show="showModal || showRuleModal ||showAwardModal ||showGameOverModal"></div>
    <!-- 次数用完弹窗 -->
    <div class="game-modal show" v-show="showModal">
      <div class="model-top">
        <div class="modal-close" @click="closeModal"></div>
      </div>
      <div class="model-main">
        <div>
          当前您的游戏次数已用完，
          立即邀请好友助力获得游戏
          机会继续划龙舟吧！
        </div>
        <div class="to-ranklist" @click="toRankList"></div>
      </div>
      <div class="model-bottom"></div>
    </div>
    <!-- 游戏规则弹窗 -->
    <div class="game-modal show" style="top:25%" v-show="showRuleModal">
      <div class="model-top">
        <div class="modal-close" @click="closeRuleModal"></div>
      </div>
      <div class="model-main" style="padding: 0.7rem 0.3rem 0.9rem 0.3rem; color:#937533">
        <div class="left-line"></div>
        <div>游戏规则</div>
        <div class="right-line"></div>
        <div class="rule-tips">
          1、倒计时3秒开始游戏；
          <br />
        </div>
        <div class="rule-tips">
          2、游戏时长30秒，单位时间内击鼓次数越多龙舟划行距离越远，按照划行距离数值大小排名顺序；
          <br />
        </div>
        <div class="rule-tips">
          3、分享一名好友并且被助力成功，可获得一次游戏机会；
          <br />
        </div>
        <div class="rule-tips">
          4、每个人只有一次获奖机会，获奖者将不能参与之后的比赛排名；
          <br />
        </div>
        <div class="rule-tips">
          5、2020年5月31号至2020年6月6号每天24点公布当天排名情况；
          <br />
        </div>
        <div class="rule-tips">
          6、每天最终排名第1名获得一等奖，第2名获得二等奖，第3名三等奖，4-10名四等奖，11-100名获得五等奖。
          <br />
        </div>
        <div class="rule-tips">7、领奖者需在2020年6月30号之前领取奖品，否则将取消资格。</div>
      </div>
      <div class="model-bottom"></div>
    </div>
    <!-- 游戏奖品弹窗 -->
    <div class="game-modal show" style="top:13%" v-show="showAwardModal">
      <div class="award-list">
        <div class="award-close" @click="closeAwardModal"></div>
      </div>
    </div>

    <!-- 活动结束弹窗 -->
    <div class="game-modal show" v-show="showGameOverModal">
      <div class="model-top">
        <div class="modal-close" @click="closeGameOverModal"></div>
      </div>
      <div class="model-main" style="padding: 0.9rem 0.3rem">
        <div>当前活动已结束</div>
        <div class="gameover-time">（活动时间：2020.05.31至2020.06.06）</div>
        <div class="to-ranklist" @click="toRankList"></div>
      </div>
      <div class="model-bottom"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showIndex: false,
      showModal: false, //弹窗
      showRuleModal: false, //游戏规则弹出
      showAwardModal: false, //游戏奖品弹窗
      JsSDKConfig: {},
      isFocus: "", //当前用户是否已关注公众号
      gameNum: "", //剩余游戏次数
      gameOver: "",
      showGameOverModal: false //游戏结束弹窗
    };
  },
  methods: {
    clear() {
      localStorage.clear();
    },

    //开始
    startGame() {
      this.$router.replace({
        path: "/Mgame"
      });
      //   if (this.gameOver == 1) {
      //     this.showGameOverModal = true;
      //   } else {
      //     let gameNum = this.gameNum;
      //     if (gameNum > 0) {
      //       this.$router.replace({
      //         path: "/Mgame"
      //       });
      //       // document.getElementById("myAudio").pause();
      //       // document.getElementById("myAudio2").play();
      //     } else {
      //       this.showModal = true;
      //     }
      //   }
    },
    //关闭弹窗
    closeModal() {
      if (this.showModal) {
        this.showModal = false;
      } else {
        this.showModal = true;
      }
    },
    //关闭规则弹窗
    closeRuleModal() {
      if (this.showRuleModal) {
        this.showRuleModal = false;
      } else {
        this.showRuleModal = true;
      }
    },
    //游戏结束弹窗
    closeGameOverModal() {
      if (this.showGameOverModal) {
        this.showGameOverModal = false;
      } else {
        this.showGameOverModal = true;
      }
    },
    //跳转排行榜
    toRankList() {
      this.$router.replace({
        path: "/Mrank"
      });
    },
    //关闭游戏奖品弹窗
    closeAwardModal() {
      if (this.showAwardModal) {
        this.showAwardModal = false;
      } else {
        this.showAwardModal = true;
      }
    },
    /**
     * 根据参数名 获取 URL 路径中的参数
     * @param {String} name 要读取的参数名称
     */
    getUrlParam(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      let url = window.location.href.split("#")[0];
      let search = url.split("?")[1];
      if (search) {
        var r = search.substr(0).match(reg);
        if (r !== null) return unescape(r[2]);
        return null;
      } else {
        return null;
      }
    },
    //判断是否关注公众号
    checkFocus() {
      let openId = localStorage.getItem("openId");
      this.$axios
        .post(
          "/h5/api/getSubscribe",
          {
            openId: openId
          },
          {}
        )
        .then(res => {
          console.log(res, "是否关注");
          if (res.data.code == 0) {
            //0为关注
            this.isFocus = 1;
            localStorage.setItem("isFocus", 1);
            let user = res.data.data.user;
            this.gameNum = user.game_num;
          } else {
            this.isFocus = 0;
            // 未关注就跳转到关注页面
            this.$router.push({
              path: "/Mfocus"
            });
          }
        });
    },
    //获取游戏次数
    getGameNum() {
      let gameNum = localStorage.getItem("gameNum2");
      if (gameNum) {
        this.gameNum = gameNum;
      } else {
        localStorage.setItem("gameNum2", 2);
        this.gameNum = 2;
      }
    },
    //获取jsconfig
    getJsSDKConfig() {
      this.$axios
        .post(
          "/weixin/api/getJsSDKConfig",
          {
            url: window.location.href
          },
          {}
        )
        .then(res => {
          if (res.data.code === 0) {
            let JsSDKConfig = res.data.data;
            let appId1 = JsSDKConfig.appId;
            let timestamp1 = JsSDKConfig.timestamp;
            let nonceStr1 = JsSDKConfig.nonceStr;
            let signature1 = JsSDKConfig.signature;
            window.wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: appId1, // 必填，公众号的唯一标识
              timestamp: timestamp1, // 必填，生成签名的时间戳
              nonceStr: nonceStr1, // 必填，生成签名的随机串
              signature: signature1, // 必填，签名，见附录1
              jsApiList: [
                "checkJsApi",
                "onMenuShareTimeline",
                "onMenuShareAppMessage",
                "onMenuShareQQ",
                "onMenuShareQZone",
                "onMenuShareWeibo",
                "updateAppMessageShareData",
                "updateTimelineShareData",
                "hideMenuItems",
                "showMenuItems",
                "hideAllNonBaseMenuItem",
                "showAllNonBaseMenuItem",
                "translateVoice",
                "startRecord",
                "stopRecord",
                "onRecordEnd",
                "playVoice",
                "pauseVoice",
                "stopVoice",
                "uploadVoice",
                "downloadVoice",
                "chooseImage",
                "previewImage",
                "uploadImage",
                "downloadImage",
                "getNetworkType",
                "openLocation",
                "getLocation",
                "hideOptionMenu",
                "showOptionMenu",
                "closeWindow",
                "scanQRCode",
                "chooseWXPay",
                "openProductSpecificView",
                "addCard",
                "chooseCard",
                "openCard"
              ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            });
            this.setWxShare();
          }
        });
    },
    //设置分享
    setWxShare() {
      let openId = localStorage.getItem("openId");
      let shareUrl = `https://smalltea.xiaoxxx.cn/#/Msupport?myopenid=${openId}`;
      console.log(shareUrl);
      // 微信分享
      window.wx.ready(() => {
        // 分享好友
        window.wx.updateAppMessageShareData({
          title: "乘风破浪·粽享端午", // 分享标题
          desc: "快来助力好友瓜分小罐茶3万大奖吧！", // 分享描述
          link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: "https://smalltea.xiaoxxx.cn/statics/share.png", // 分享图标
          success: function() {
            console.log(url);
            // 设置成功
            // window._czc.push(['_trackEvent', '祝福语页面分享--微信', '分享好友次数', '分享好友次数', '1', '1']);
          }
        });
        // 分享朋友圈
        window.wx.updateTimelineShareData({
          title: "乘风破浪·粽享端午", // 分享标题
          link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: "https://smalltea.xiaoxxx.cn/statics/share.png", // 分享图标
          success: function() {
            // 设置成功
            window._czc.push([
              "_trackEvent",
              "祝福语页面分享--微信",
              "分享朋友圈次数",
              "分享朋友圈次数",
              "1",
              "1"
            ]);
          }
        });
        // 1.2.0 老接口
        wx.onMenuShareAppMessage({
          title: "乘风破浪·粽享端午", // 分享标题
          desc: "快来助力好友瓜分小罐茶3万大奖吧！", // 分享描述
          link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: "https://smalltea.xiaoxxx.cn/statics/share.png", // 分享图标
          success: function() {
            // 设置成功
            // window._czc.push(['_trackEvent', '祝福语页面分享--微信', '分享好友次数', '分享好友次数', '1', '1']);
          }
        });
        wx.onMenuShareTimeline({
          title: "乘风破浪·粽享端午", // 分享标题
          link: shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: "https://smalltea.xiaoxxx.cn/statics/share.png", // 分享图标
          success: function() {
            // 设置成功
            window._czc.push([
              "_trackEvent",
              "祝福语页面分享--微信",
              "分享朋友圈次数",
              "分享朋友圈次数",
              "1",
              "1"
            ]);
          }
        });
      });
    }
  },
  created() {
    // let need_support = localStorage.getItem("need_support");
    // if (need_support == 0 || !need_support) {
    //   this.getJsSDKConfig();
    //   //获取游戏次数
    //   this.getGameNum();
    //   let href = window.location.href;
    //   let have_param = href.indexOf("?");
    //   //检查是否关注
    //   if (have_param == -1) {
    //     //如果没有参数
    //     let openId = localStorage.getItem("openId");
    //     if (openId) {
    //       //检测是否关注
    //       this.checkFocus();
    //     } else {
    //       //如果缓存中没有openid,再走去授权
    //       window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxfda9ee4f018ce8ee&redirect_uri=https://api.smalltea.xiaoxxx.cn/weixin/api/callbackFortune?returnUrl=https://smalltea.xiaoxxx.cn&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
    //     }
    //   } else {
    //     let openId = this.getUrlParam("openid");
    //     console.log(openId);
    //     let avatar = this.getUrlParam("avatar");
    //     avatar = decodeURIComponent(avatar);
    //     // console.log(avatar)
    //     // let username = decodeURIComponent(this.getUrlParam('nickname'))
    //     // let username = this.getUrlParam('nickname')
    //     let str;
    //     str = href.substr(have_param + 1); //取得所有参数
    //     str = href.match(/(\S*)#/)[1];
    //     var arr = href.split("&");
    //     // var openId = '';
    //     // console.log(arr)
    //     for (var i = 0; i < arr.length; i++) {
    //       if (arr[i].split("=")[0] == "openid") {
    //         // openId = arr[i].split('=')[1]
    //       } else if (arr[i].split("=")[0] == "avatar") {
    //         // let avatar = arr[i].split('=')[1]
    //         // window.localStorage.setItem('avatar', decodeURIComponent(avatar))
    //         // alert()
    //       } else if (arr[i].split("=")[0] == "nickname") {
    //         let username = decodeURIComponent(arr[i].split("=")[1]).replace(
    //           /#\//i,
    //           ""
    //         );
    //         window.localStorage.setItem("username", username);
    //       }
    //     }
    //     if (openId) {
    //       //如果没有任何一个信息，就再去授权
    //       window.localStorage.setItem("openId", openId);
    //       window.localStorage.setItem("avatar", avatar);
    //       // window.localStorage.setItem('username', username)
    //       //检测是否关注
    //       this.checkFocus();
    //     } else {
    //       window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxfda9ee4f018ce8ee&redirect_uri=https://api.smalltea.xiaoxxx.cn/weixin/api/callbackFortune?returnUrl=https://smalltea.xiaoxxx.cn&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`;
    //     }
    //   }
    // } else if (need_support == 1) {
    //   let href = window.location.href;
    //   let have_param = href.indexOf("?");
    //   let str;
    //   let openId = this.getUrlParam("openid");
    //   let avatar = this.getUrlParam("avatar");
    //   avatar = decodeURIComponent(avatar);
    //   str = href.substr(have_param + 1); //取得所有参数
    //   str = href.match(/(\S*)#/)[1];
    //   var arr = href.split("&");
    //   console.log(arr);
    //   for (var i = 0; i < arr.length; i++) {
    //     if (arr[i].split("=")[0] == "openid") {
    //       console.log(arr[i].split("=")[1]);
    //       // openId = arr[i].split('=')[1]
    //     } else if (arr[i].split("=")[0] == "avatar") {
    //     } else if (arr[i].split("=")[0] == "nickname") {
    //       let username = decodeURIComponent(arr[i].split("=")[1]).replace(
    //         /#\//i,
    //         ""
    //       );
    //       window.localStorage.setItem("username", username);
    //     }
    //   }
    //   // alert(openId)
    //   if (openId) {
    //     //如果没有任何一个信息，就再去授权
    //     window.localStorage.setItem("openId", openId);
    //     window.localStorage.setItem("avatar", avatar);
    //     // window.localStorage.setItem('username', username)
    //     //检测是否关注
    //     // if (!need_support) {
    //     //     this.checkFocus()
    //     // }
    //     setTimeout(() => {
    //       let supportOpenid = localStorage.getItem("bbbbbb");
    //       this.$router.push({
    //         path: "/Msupport",
    //         query: {
    //           support: supportOpenid
    //         }
    //       });
    //     });
    //   }
    // }
  },
  mounted() {
    setTimeout(() => {
      this.showIndex = true;
      this.gameOver = localStorage.getItem("game-over");
    });

    // let need_support = localStorage.getItem('need_support')
    // if (need_support == 1) {
    //     setTimeout(() => {
    //         let supportOpenid = localStorage.getItem('bbbbbb')
    //         this.$router.push({
    //             path: '/Msupport',
    //             query: {
    //                 support: supportOpenid
    //             }
    //         })
    //     })
    // }
  }
};
</script>

<style scoped>
.index {
  position: relative;
  width: 100%;
  height: 100vh;
  min-height: 13rem;
  background: url("../../assets/H5img/indexImg/bg-index.jpg") no-repeat;
  background-size: cover;
  background-position: center;
  overflow: hidden;
}

.main-wrapper {
  position: absolute;
  width: 100%;
  height: 13rem;
  top: 50%;
  transform: translateY(-50%);
}

.logo-con {
  position: absolute;
  /* top: 0.32rem; */
  top: 5%;
  left: 50%;
  width: 3.6rem;
  height: 0.75rem;
  transform: translateX(-50%);
}

.logo {
  position: relative;
  width: 2.53rem;
  height: 0.56rem;
  background: url("../../assets/H5img/indexImg/logo.png") no-repeat;
  background-size: cover;
  background-position: center;
  margin: 0 auto;
  margin-top: 0.1rem;
  z-index: 2;
}

.cloud-3 {
  position: absolute;
  width: 1.86rem;
  height: 0.7rem;
  left: 0.1rem;
  top: 0rem;
  background: url("../../assets/H5img/indexImg/cloud-3.png") no-repeat;
  background-size: cover;
  background-position: center;
}

.cloud-2 {
  position: absolute;
  top: 4.37rem;
  left: 0.52rem;
  width: 1.3rem;
  height: 0.49rem;
  background: url("../../assets/H5img/indexImg/cloud-3.png") no-repeat;
  background-size: cover;
  background-position: center;
  animation: cloud 3s ease-in alternate infinite;
}

.cloud-1 {
  position: absolute;
  top: 4.06rem;
  left: 5rem;
  width: 2.06rem;
  height: 0.77rem;
  background: url("../../assets/H5img/indexImg/cloud-1.png") no-repeat;
  background-size: cover;
  background-position: center;
  animation: cloud2 3s ease-in alternate infinite;
  animation-delay: 1s;
}

.mountain {
  position: absolute;
  top: 1.85rem;
  left: 0;
  width: 7.5rem;
  height: 6.18rem;
  background: url("../../assets/H5img/indexImg/mountain.png") no-repeat;
  background-size: cover;
  background-position: center;
}

.waterfall-top {
  position: absolute;
  top: 5.37rem;
  width: 7.5rem;
  height: 4.33rem;
  background: url("../../assets/H5img/indexImg/waterfall-top.png") no-repeat;
  background-size: cover;
  background-position: center;
  animation: waterfall-top 0.9s linear alternate infinite;
}

.boat {
  position: absolute;
  top: 4.7rem;
  left: 0.96rem;
  width: 5.22rem;
  height: 4.33rem;
  background: url("../../assets/H5img/indexImg/index-boat.png") no-repeat;
  background-size: cover;
  background-position: center;
  animation: boat 1.8s ease-in-out alternate infinite;
  -webkit-animation: boat 1.8s ease-in-out alternate infinite;
}

.quant-con {
  position: absolute;
  top: 4.7rem;
  left: 0.96rem;
  width: 5.22rem;
  height: 4.33rem;
  animation: boat 1.8s ease-in-out alternate infinite;
}

.front-quant {
  position: absolute;
  top: 2.8rem;
  left: 2.7rem;
  width: 1.82rem;
  height: 1.74rem;
  background: url("../../assets/H5img/indexImg/front-quant.png") no-repeat;
  background-size: cover;
  background-position: center;
  z-index: 2;
  animation: quant 1.8s ease-in-out alternate infinite;
  transform-origin: top left;
}

.back-quant {
  position: absolute;
  top: 2.52rem;
  left: 3.76rem;
  width: 1.82rem;
  height: 1.75rem;
  background: url("../../assets/H5img/indexImg/back-quant.png") no-repeat;
  background-size: cover;
  background-position: center;
  z-index: 2;
  animation: quant 1.8s ease-in-out alternate infinite;
  transform-origin: top left;
}

.water-3 {
  position: absolute;
  width: 7.18rem;
  height: 2.57rem;
  top: 7.7rem;
  right: 0;
  background: url("../../assets/H5img/indexImg/water-3.png") no-repeat;
  background-size: cover;
  background-position: center;
}

.water-4 {
  position: absolute;
  width: 7.5rem;
  height: 3.63rem;
  top: 6.85rem;
  right: 0;
  background: url("../../assets/H5img/indexImg/water-4.png") no-repeat;
  background-size: cover;
  background-position: center;
}

.waterfall-middle {
  position: absolute;
  width: 6.14rem;
  height: 2.85rem;
  top: 7.25rem;
  right: 0;
  background: url("../../assets/H5img/indexImg/waterfall-middle.png") no-repeat;
  background-size: cover;
  background-position: center;
  animation: waterfall-middle 0.9s linear alternate infinite;
}

.water-1 {
  position: absolute;
  width: 7.8rem;
  height: 2.54rem;
  top: 8.79rem;
  right: 0;
  background: url("../../assets/H5img/indexImg/water-1.png") no-repeat;
  background-size: cover;
  background-position: center;
  animation: water-1 2.5s linear alternate infinite;
  z-index: 0;
}

.water-2 {
  position: absolute;
  width: 7.14rem;
  height: 2.47rem;
  top: 9.2rem;
  right: 0;
  background: url("../../assets/H5img/indexImg/water-2.png") no-repeat;
  background-size: cover;
  background-position: center;
  animation: water-2 0.9s linear alternate infinite;
}

.waterfall-botom {
  position: absolute;
  width: 6.3rem;
  height: 4rem;
  top: 8.6rem;
  left: 0rem;
  background: url("../../assets/H5img/indexImg/waterfall-bottom.png") no-repeat;
  background-size: cover;
  background-position: center;
  z-index: 3;
}

.bottom-bg {
  position: absolute;
  width: 7.5rem;
  height: 4rem;
  /* bottom: -8%; */
  bottom: -1.1rem;
  left: 0rem;
  background: url("../../assets/H5img/indexImg/bottom-bg.png") no-repeat;
  background-size: cover;
  background-position: center;
}

.index-title {
  position: absolute;
  top: 1.4rem;
  left: 0.65rem;
  width: 6.28rem;
  height: 2.79rem;
  /* background: url('../../assets/H5img/indexImg/index-title.png') no-repeat;
    background-size: cover;
    background-position: center; */
}

.small-titlle {
  position: absolute;
  top: 2.08rem;
  left: 0.25rem;
  width: 4.41rem;
  height: 0.71rem;
  background: url("../../assets/H5img/indexImg/s-title.png") no-repeat;
  background-size: cover;
  background-position: center;
}

.hit-text {
  position: absolute;
  top: 0.3rem;
  left: 0.22rem;
  width: 1.53rem;
  height: 1.58rem;
  background: url("../../assets/H5img/indexImg/ji.png") no-repeat;
  background-size: cover;
  background-position: center;
  animation: title1 1.5s ease-out alternate infinite;
}

.dou {
  position: absolute;
  top: 1.7rem;
  left: 1.88rem;
  width: 0.15rem;
  height: 0.19rem;
  background: url("../../assets/H5img/indexImg/dou.png") no-repeat;
  background-size: cover;
  background-position: center;
}

.title-after {
  position: absolute;
  top: 0rem;
  left: 2.22rem;
  width: 3.89rem;
  height: 1.91rem;
  background: url("../../assets/H5img/indexImg/title-after.png") no-repeat;
  background-size: cover;
  background-position: center;
  animation: title2 1.5s ease-out alternate infinite;
}

.bottom-container {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  bottom: 1.77rem;
  width: 100%;
  z-index: 4;
}

.game-award {
  width: 0.91rem;
  height: 1.07rem;
  background: url("../../assets/H5img/indexImg/award.png") no-repeat;
  background-size: cover;
  background-position: center;
}

.game-start {
  position: relative;
  width: 2.2rem;
  height: 2.23rem;
  background: url("../../assets/H5img/indexImg/drum.png") no-repeat;
  background-size: cover;
  background-position: center;
  margin: 0 0.8rem;
}

.left-drumstick {
  position: absolute;
  width: 0.98rem;
  height: 1.21rem;
  top: 1rem;
  left: -0.4rem;
  background: url("../../assets/H5img/indexImg/left-drumstick.png") no-repeat;
  background-size: cover;
  background-position: center;
  animation: left-drumstick 0.25s linear infinite alternate;
}

.right-drumstick {
  position: absolute;
  width: 1.07rem;
  height: 1.14rem;
  top: 1rem;
  right: -0.4rem;
  background: url("../../assets/H5img/indexImg/right-drumstick.png") no-repeat;
  background-size: cover;
  background-position: center;
  animation: right-drumstick 0.25s linear infinite alternate;
}

.game-rule {
  width: 0.94rem;
  height: 1.09rem;
  background: url("../../assets/H5img/indexImg/rules.png") no-repeat;
  background-size: cover;
  background-position: center;
}

/* 云飘动 */
@keyframes cloud {
  from {
    transform: translateX(-15px);
  }

  to {
    transform: translateX(0px);
  }
}

@keyframes cloud2 {
  from {
    transform: translateX(0.1rem);
  }

  to {
    transform: translateX(-0.5rem);
  }
}

@keyframes waterfall-top {
  from {
    /* top: 5.37rem; */
    transform: translate3d(0, 0, 0);
  }

  to {
    transform: translate3d(0, -0.2rem, 0);
  }
}

@keyframes waterfall-middle {
  from {
    /* top: 5.37rem; */
    transform: translate3d(0, 0, 0);
  }

  to {
    transform: translate3d(0.2rem, 0rem, 0);
  }
}

@keyframes water-1 {
  from {
    /* top: 5.37rem; */
    transform: translate3d(0, 0, 0);
  }

  to {
    transform: translate3d(0.2rem, 0, 0);
  }
}

@keyframes water-2 {
  from {
    /* top: 5.37rem; */
    transform: translate3d(0, 0, 0);
  }

  to {
    transform: translate3d(0.1rem, 0.1rem, 0);
  }
}

@keyframes boat {
  0% {
    transform: translate3d(0.3rem, 0.15rem, 0);
    /* transform: translate3d(0, 0, 0); */
  }

  50% {
    transform: translate3d(0, 0, 0);
  }

  100% {
    /* transform: translate3d(0, 0, 0); */
    transform: translate3d(0.3rem, 0.15rem, 0);
  }
}

@-webkit-keyframes boat {
  0% {
    /* top: 5.37rem; */
    transform: translate3d(0.3rem, 0.15rem, 0);
    /* transform: translate3d(0, 0, 0); */
  }

  50% {
    transform: translate3d(0, 0, 0);
  }

  100% {
    /* transform: translate3d(0, 0, 0); */
    transform: translate3d(0.3rem, 0.15rem, 0);
  }
}

@keyframes quant {
  0% {
    transform: rotateZ(20deg);
  }

  50% {
    transform: rotateZ(0deg);
  }

  100% {
    /* transform: translate3d(0, 0, 0); */
    transform: rotateZ(20deg);
  }
}

@keyframes left-drumstick {
  0% {
    transform: translate3d(-3px, 0, 0);
  }

  50% {
    transform: translate3d(0, 0, 1rem);
  }

  100% {
    transform: translate3d(-3px, 0, 0);
  }
}

@keyframes right-drumstick {
  0% {
    transform: translate3d(3px, 0, 0);
  }

  50% {
    transform: translate3d(0rem, 0, 1rem);
  }

  100% {
    transform: translate3d(3px, 0, 0);
  }
}

/* 标题动画 */
@keyframes title1 {
  from {
    transform: translate3d(0, -0.1rem, 0);
  }

  to {
    transform: translate3d(0, 0.1rem, 0);
  }
}

@keyframes title2 {
  from {
    transform: translate3d(0, 0.1rem, 0);
  }

  to {
    transform: translate3d(0, -0.1rem, 0);
  }
}

.left-line {
  position: absolute;
  top: 0.95rem;
  left: 0.4rem;
  width: 1.33rem;
  height: 1px;
  background-color: #d6bd87;
}

.right-line {
  position: absolute;
  top: 0.95rem;
  right: 0.4rem;
  width: 1.33rem;
  height: 1px;
  background-color: #d6bd87;
}

.rule-tips {
  text-align: left;
  color: #937533;
  padding-left: 18px;
  text-indent: -18px;
  font-size: 0.24rem;
  font-weight: normal;
  margin-top: 0.1rem;
}

.award-close {
  position: absolute;
  top: -0.8rem;
  right: -0.1rem;
  width: 0.5rem;
  height: 0.48rem;
  background: url("../../assets/H5img/model/close-icon.png") no-repeat;
  background-size: cover;
  background-position: center;
}

.award-list {
  width: 5.86rem;
  height: 10.03rem;
  background: url("../../assets/H5img/indexImg/award-list.png");
  background-size: cover;
  background-position: center;
}

.game-num {
  position: absolute;
  bottom: 0.6rem;
  color: #724034;
  font-size: 0.22rem;
  left: 50%;
  transform: translateX(-50%);
}

.to-ranklist {
  width: 3.55rem;
  height: 0.92rem;
  margin: 0 auto;
  background: url("../../assets/H5img/model/to-ranklist.png");
  background-size: cover;
  background-position: center;
  margin-top: 0.4rem;
}
</style>
